import React from 'react';
import Icon from '../atoms/Icon';

function RankingRiserIcon(props: any, ref: React.Ref<any>) {
  return (
    <Icon {...props} ref={ref}>
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
        width="100%" viewBox="0 0 272 449" enable-background="new 0 0 272 449">
        <path fill="#FFFFFF" opacity="1.000000" stroke="none"
          d="
          M99.000000,450.000000 
            C97.933327,450.000000 96.866661,450.000000 95.395798,449.626770 
            C92.758530,444.988159 90.525452,440.722717 88.310181,436.491333 
            C93.406036,433.571533 95.384377,428.868774 94.885849,423.342682 
            C94.398354,417.938843 90.690231,413.497314 85.905655,413.174835 
            C78.367607,412.666779 70.770164,413.039703 63.000000,413.039703 
            C63.000000,425.768738 63.000000,437.884369 63.000000,450.000000 
            C42.413666,450.000000 21.827333,450.000000 1.000000,450.000000 
            C1.000000,433.313202 1.000000,416.625275 1.462943,399.468658 
            C5.196998,399.000000 8.468109,399.000000 12.109800,399.000000 
            C12.109800,394.354858 12.109800,390.273071 12.109800,384.678101 
            C14.106625,386.545685 15.740025,387.334473 16.056057,388.485107 
            C18.732214,398.228516 25.413630,400.548401 34.504665,399.055634 
            C36.774933,398.682831 39.163067,399.083771 41.487148,398.953156 
            C42.326012,398.906006 43.779358,398.458832 43.862156,397.998230 
            C45.040497,391.443420 50.041569,393.143616 54.246048,392.978333 
            C57.655716,392.844299 60.920361,392.617981 61.228081,397.437500 
            C61.263870,397.998047 62.706352,398.899872 63.508644,398.912994 
            C70.607010,399.029297 77.708076,398.980530 85.070473,398.980530 
            C85.070473,392.418701 85.070473,386.500244 85.070473,379.203705 
            C88.838867,384.331696 92.597160,388.095642 94.701492,392.627625 
            C97.816551,399.336273 102.588173,399.971924 108.707077,398.543304 
            C108.707077,386.388550 108.707077,374.327789 108.707077,362.320129 
            C105.008377,362.320129 101.611847,362.320129 97.720726,362.320129 
            C97.720726,367.949707 97.720726,373.266449 97.720726,379.961548 
            C93.801964,374.228699 90.780861,369.627441 87.542412,365.184631 
            C86.599602,363.891205 85.140938,362.357239 83.735336,362.144379 
            C80.685814,361.682526 77.517975,362.001953 73.530319,362.001953 
            C73.530319,373.867523 73.530319,385.306458 73.530319,396.745392 
            C73.165184,396.751038 72.800041,396.756714 72.434906,396.762360 
            C68.090691,385.204437 63.746468,373.646515 59.428764,362.159149 
            C46.155231,361.587280 46.158306,361.588318 41.947781,374.108948 
            C41.690807,374.873077 41.301720,375.591675 41.013866,376.346649 
            C38.384007,383.243958 35.762981,390.144653 32.959320,397.517883 
            C30.419317,393.023071 28.287436,389.250488 26.175220,385.512726 
            C26.459305,385.164612 26.622496,384.836151 26.887058,384.659576 
            C32.041683,381.219604 34.092056,376.210083 32.475319,370.952698 
            C30.362083,364.080750 27.613209,362.018372 20.483679,362.002960 
            C13.989147,361.988922 7.494562,362.000000 1.000000,362.000000 
            C1.000000,241.765686 1.000000,121.531380 1.000000,1.000000 
            C57.687214,1.000000 114.374947,1.000000 171.446121,1.332742 
            C165.006683,10.525575 158.183823,19.385666 151.465973,28.109373 
            C147.085876,25.574368 143.237885,23.159084 139.197510,21.126181 
            C138.019104,20.533264 135.971695,20.474003 134.863922,21.111197 
            C114.644165,32.741570 94.477608,44.465446 74.360252,56.272549 
            C52.427303,69.145241 30.606031,82.209373 8.598725,94.952858 
            C5.660969,96.653984 4.927406,98.426346 4.936873,101.551979 
            C5.038321,135.046021 4.982320,168.540527 5.007486,202.034866 
            C5.020003,218.694839 5.111111,235.354736 5.129249,252.274445 
            C5.388587,252.633911 5.685341,252.733627 6.309779,252.980865 
            C13.295303,257.122559 19.929588,261.156616 26.615667,265.102936 
            C42.933872,274.734467 59.252892,284.364990 75.615051,293.921509 
            C92.107567,303.554169 108.981865,312.584167 125.036705,322.893890 
            C133.157852,328.108887 139.217178,329.462494 148.062622,323.833496 
            C168.123520,311.067169 189.097275,299.739746 209.639526,287.724060 
            C228.508331,276.687225 247.255798,265.442230 266.168671,254.482117 
            C268.982330,252.851578 270.065857,251.122879 270.060181,247.906204 
            C269.973602,198.937805 269.963715,149.969101 270.095795,101.000900 
            C270.103210,98.244682 269.128082,96.780930 267.039337,95.580315 
            C260.305542,91.709801 253.421524,88.076454 246.870331,83.918518 
            C238.375916,78.527237 229.168274,74.611816 222.797470,65.681023 
            C207.118637,43.701946 190.337723,22.509050 174.000000,1.000001 
            C206.969971,1.000000 239.939941,1.000000 273.000000,1.000000 
            C273.000000,128.020874 273.000000,255.041779 272.663635,382.427368 
            C270.512817,378.630280 266.901764,377.026093 262.823303,375.975647 
            C259.424500,375.100220 256.073120,374.040741 252.700775,373.062744 
            C252.762604,372.518585 252.824432,371.974396 252.886261,371.430206 
            C253.819366,370.956818 254.871979,369.931854 255.665222,370.103760 
            C259.469238,370.928101 263.203125,372.076202 267.405884,373.231323 
            C268.050873,372.391144 268.909729,370.969604 270.055237,369.838379 
            C273.182861,366.749908 272.321106,364.760559 268.396240,363.845062 
            C263.707275,362.751312 258.937805,361.097382 254.230377,361.182800 
            C245.318405,361.344513 239.411652,370.069641 243.472733,377.328217 
            C245.206970,380.427856 249.838135,382.154602 253.452332,383.876892 
            C256.396790,385.279999 259.787140,385.747467 263.776062,386.849884 
            C256.548218,393.660583 251.355865,387.286255 245.832245,385.824432 
            C244.081726,388.402679 242.468872,390.778198 240.874786,393.126068 
            C251.140167,401.770020 263.857971,401.253082 273.000000,392.000000 
            C273.000000,411.263184 273.000000,430.526337 273.000000,450.000000 
            C252.312912,450.000000 231.625122,450.000000 210.468292,449.614349 
            C208.057327,445.008606 206.115402,440.788483 204.101547,436.412048 
            C204.634491,436.000427 205.258453,435.483337 205.917206,435.015167 
            C210.908691,431.467743 211.012985,425.860657 209.623489,421.287292 
            C208.627579,418.009338 204.627441,413.902679 201.443268,413.383850 
            C194.213257,412.205811 186.659821,413.012695 179.000000,413.012695 
            C179.000000,425.743469 179.000000,437.871735 179.000000,450.000000 
            C177.611115,450.000000 176.222214,450.000000 174.416656,449.541504 
            C174.000000,446.479492 174.000000,443.875977 174.000000,440.859100 
            C168.026230,440.859100 162.611145,440.859100 156.953201,440.859100 
            C157.059387,438.669006 157.143356,436.936951 157.248184,434.774841 
            C163.060471,434.774841 168.474380,434.774841 173.809952,434.774841 
            C173.809952,432.033234 173.809952,429.748230 173.809952,427.020721 
            C168.220306,427.020721 162.799545,427.020721 157.223969,427.020721 
            C157.223969,425.179474 157.223969,423.785400 157.223969,421.942627 
            C162.842560,421.942627 168.260849,421.942627 173.721283,421.942627 
            C173.721283,418.758942 173.721283,416.031311 173.721283,413.301514 
            C164.712860,413.301514 155.986343,413.301514 147.000000,413.301514 
            C147.000000,425.734192 147.000000,437.867096 147.000000,450.000000 
            C143.307098,450.000000 139.614182,450.000000 135.580475,449.651306 
            C140.867493,447.562439 143.980515,443.385864 143.999939,437.549408 
            C144.017014,432.417755 141.841995,429.901215 135.464981,427.889252 
            C131.665146,426.690399 127.821976,425.628937 123.450829,424.344879 
            C124.239975,423.082428 124.937126,421.345184 125.345024,421.410645 
            C129.525391,422.081421 133.658829,423.044678 138.525070,424.079285 
            C139.695938,422.543640 141.448853,420.244568 143.134399,418.033875 
            C138.654236,411.594116 124.933495,410.476410 118.592903,414.181183 
            C111.648567,418.238770 110.514732,429.586975 118.470108,432.854858 
            C121.993637,434.302246 125.879005,434.845795 129.500946,436.088684 
            C130.806259,436.536560 131.821213,437.830627 132.968674,438.738525 
            C131.719742,439.492218 130.337738,441.035431 129.246811,440.851562 
            C125.974037,440.300049 122.842735,438.959320 119.596558,438.172913 
            C118.440102,437.892731 116.569405,437.821747 115.948479,438.500427 
            C110.632561,444.310547 110.949059,445.477600 118.158363,448.621735 
            C119.122520,449.042297 120.053604,449.538727 121.000000,450.000000 
            C117.307091,450.000000 113.614182,450.000000 109.460632,449.531342 
            C109.000000,437.136505 109.000000,425.210327 109.000000,413.306335 
            C105.370728,413.306335 102.307930,413.306335 99.000000,413.306335 
            C99.000000,425.740570 99.000000,437.870270 99.000000,450.000000 
          M173.037537,362.000122 
            C170.439789,362.000122 167.842041,362.000122 165.293732,362.000122 
            C165.293732,374.646484 165.293732,386.694519 165.293732,398.682587 
            C168.655823,398.682587 171.716736,398.682587 175.256958,398.682587 
            C175.256958,392.058228 175.256958,385.746063 175.256958,377.997742 
            C179.181412,383.746979 182.518555,388.135132 185.304169,392.849213 
            C188.464569,398.197479 192.556686,400.501862 198.742844,398.484253 
            C198.742844,386.437500 198.742844,374.387909 198.742844,362.278198 
            C195.420380,362.278198 192.360977,362.278198 188.832397,362.278198 
            C188.832397,368.202515 188.832397,373.862732 188.832397,380.627838 
            C186.442261,377.134766 184.899170,374.494110 182.979218,372.163910 
            C180.094116,368.662354 176.945007,365.378326 173.037537,362.000122 
          M238.984207,391.748291 
            C238.984207,386.969543 238.984207,382.190765 238.984207,377.236450 
            C232.830154,377.236450 227.104858,377.236450 221.247009,377.236450 
            C221.247009,380.211395 221.247009,382.946075 221.247009,386.000061 
            C222.781799,386.000061 224.086594,385.945526 225.384567,386.016144 
            C226.568680,386.080627 227.745407,386.280762 229.255539,386.460358 
            C225.361389,390.793060 221.318207,391.171112 217.496338,387.969635 
            C213.427368,384.561188 212.317322,377.390442 215.807297,373.860199 
            C219.166397,370.462311 223.263702,368.300507 227.832474,372.081970 
            C229.246307,373.252228 232.124359,373.107971 234.236816,372.833282 
            C235.877670,372.619904 237.370544,371.268524 238.924652,370.425415 
            C235.083450,361.421692 225.977844,358.716980 213.952759,362.966766 
            C205.743256,365.868103 200.829208,376.225037 203.496429,385.004761 
            C208.169968,400.388885 227.262009,404.482849 238.984207,391.748291 
          M143.015915,367.476288 
            C144.240295,365.828461 145.464691,364.180664 147.084991,362.000000 
            C144.308243,362.000000 142.178650,362.203705 140.102554,361.957062 
            C135.945908,361.463257 132.951920,362.551361 130.810623,366.520447 
            C129.200638,369.504700 126.679741,371.997498 123.740723,375.764832 
            C123.740723,370.295288 123.740723,366.226746 123.740723,362.366150 
            C120.254807,362.366150 117.193199,362.366150 114.369957,362.366150 
            C114.369957,374.790802 114.369957,386.847015 114.369957,398.783264 
            C117.693832,398.783264 120.643578,398.783264 123.555222,398.783264 
            C124.878250,387.930817 124.878250,387.930817 126.849800,386.488342 
            C135.904007,399.766846 138.693878,401.300659 148.080658,398.008270 
            C144.060028,392.834473 140.167694,387.626343 136.044556,382.607880 
            C134.113297,380.257324 133.666199,378.165619 135.723602,375.792786 
            C137.980927,373.189331 140.246490,370.593048 143.015915,367.476288 
          M160.000000,379.500854 
            C160.000000,373.751770 160.000000,368.002686 160.000000,362.313904 
            C156.011002,362.313904 152.621399,362.313904 149.295685,362.313904 
            C149.295685,374.666656 149.295685,386.703369 149.295685,398.686584 
            C152.990204,398.686584 156.380402,398.686584 160.000000,398.686584 
            C160.000000,392.416718 160.000000,386.458344 160.000000,379.500854 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M5.166666,252.014679 
            C5.111111,235.354736 5.020003,218.694839 5.007486,202.034866 
            C4.982320,168.540527 5.038321,135.046021 4.936873,101.551979 
            C4.927406,98.426346 5.660969,96.653984 8.598725,94.952858 
            C30.606031,82.209373 52.427303,69.145241 74.360252,56.272549 
            C94.477608,44.465446 114.644165,32.741570 134.863922,21.111197 
            C135.971695,20.474003 138.019104,20.533264 139.197510,21.126181 
            C143.237885,23.159084 147.085876,25.574368 151.465973,28.109373 
            C158.183823,19.385666 165.006683,10.525575 171.914780,1.332742 
            C172.444443,1.000000 172.888901,1.000000 173.666672,1.000001 
            C190.337723,22.509050 207.118637,43.701946 222.797470,65.681023 
            C229.168274,74.611816 238.375916,78.527237 246.870331,83.918518 
            C253.421524,88.076454 260.305542,91.709801 267.039337,95.580315 
            C269.128082,96.780930 270.103210,98.244682 270.095795,101.000900 
            C269.963715,149.969101 269.973602,198.937805 270.060181,247.906204 
            C270.065857,251.122879 268.982330,252.851578 266.168671,254.482117 
            C247.255798,265.442230 228.508331,276.687225 209.639526,287.724060 
            C189.097275,299.739746 168.123520,311.067169 148.062622,323.833496 
            C139.217178,329.462494 133.157852,328.108887 125.036705,322.893890 
            C108.981865,312.584167 92.107567,303.554169 75.615051,293.921509 
            C59.252892,284.364990 42.933872,274.734467 26.615667,265.102936 
            C19.929588,261.156616 13.295303,257.122559 6.217964,252.804718 
            C5.634987,252.261795 5.424387,252.106323 5.166666,252.014679 
          M110.997833,83.184258 
            C110.984207,82.751648 110.970589,82.319046 111.221916,81.258034 
            C119.929390,69.888405 128.674622,58.547207 137.288071,47.106796 
            C138.186218,45.913876 138.303833,44.133305 138.783600,42.625385 
            C120.458740,52.086815 103.416481,62.036404 86.434418,72.087692 
            C75.893532,78.326591 65.443939,84.719719 55.005161,90.993134 
            C55.005161,90.993134 55.053905,90.939720 54.311501,91.000519 
            C45.050774,96.317268 35.721279,101.521057 26.603188,107.072105 
            C25.229691,107.908287 24.112587,110.363174 24.106964,112.073341 
            C23.970028,153.729828 24.044077,195.386978 23.934168,237.043625 
            C23.922752,241.370193 25.900160,243.126587 30.171253,243.940613 
            C30.171253,232.818893 30.171253,222.056396 30.171253,211.306274 
            C52.291962,211.306274 74.019020,211.306274 95.969818,211.306274 
            C95.969818,235.576324 95.969818,259.541656 95.969818,283.402466 
            C98.720222,284.855591 101.249809,286.192078 104.276215,287.791046 
            C104.276215,249.298843 104.276215,211.236221 104.276215,173.369873 
            C126.420364,173.369873 148.148605,173.369873 170.131683,173.369873 
            C170.131683,211.638214 170.131683,249.537292 170.131683,287.495941 
            C176.049683,286.105164 178.203110,283.030884 178.165878,276.767426 
            C177.868668,226.780853 178.000000,176.791763 178.000000,126.803436 
            C178.000000,125.014404 178.000000,123.225372 178.000000,121.237488 
            C200.152710,121.237488 221.879349,121.237488 244.074890,121.237488 
            C244.074890,162.465607 244.074890,203.459213 244.074890,244.196304 
            C251.246170,243.083115 251.098709,238.199417 251.078888,232.791550 
            C250.932892,192.968048 250.958176,153.143661 251.073776,113.319969 
            C251.083786,109.871780 249.894882,108.023193 246.942001,106.358276 
            C237.773331,101.188713 228.841736,95.600410 219.714249,90.355370 
            C215.219269,87.772362 210.495560,85.587410 204.913239,82.729820 
            C204.913239,93.454559 204.913239,102.549507 204.913239,111.722710 
            C200.767075,111.722710 197.036850,111.722710 193.304291,111.722710 
            C193.304291,98.380646 193.304291,85.318062 193.304291,71.995758 
            C199.532684,71.995758 205.463333,71.995758 212.378540,71.995758 
            C199.082123,54.466045 186.274887,37.581245 172.974030,20.045670 
            C159.654205,37.581562 146.833969,54.459724 133.384232,72.166656 
            C140.419266,72.166656 146.216782,72.166656 152.200317,72.518417 
            C152.364410,72.737686 152.575424,72.893364 152.980682,73.914299 
            C152.931564,104.280968 152.882462,134.647644 152.481583,165.200333 
            C152.262344,165.364426 152.106659,165.575439 151.113327,165.980209 
            C148.070786,165.931259 145.028229,165.882294 141.799667,165.481583 
            C141.635574,165.262344 141.424561,165.106659 141.019333,164.085678 
            C141.019333,137.451126 141.019333,110.816582 141.019333,83.833420 
            C130.546616,83.833420 120.773766,83.833420 110.997833,83.184258 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M1.000000,362.468658 
            C7.494562,362.000000 13.989147,361.988922 20.483679,362.002960 
            C27.613209,362.018372 30.362083,364.080750 32.475319,370.952698 
            C34.092056,376.210083 32.041683,381.219604 26.887058,384.659576 
            C26.622496,384.836151 26.459305,385.164612 26.175220,385.512726 
            C28.287436,389.250488 30.419317,393.023071 32.959320,397.517883 
            C35.762981,390.144653 38.384007,383.243958 41.013866,376.346649 
            C41.301720,375.591675 41.690807,374.873077 41.947781,374.108948 
            C46.158306,361.588318 46.155231,361.587280 59.428764,362.159149 
            C63.746468,373.646515 68.090691,385.204437 72.434906,396.762360 
            C72.800041,396.756714 73.165184,396.751038 73.530319,396.745392 
            C73.530319,385.306458 73.530319,373.867523 73.530319,362.001953 
            C77.517975,362.001953 80.685814,361.682526 83.735336,362.144379 
            C85.140938,362.357239 86.599602,363.891205 87.542412,365.184631 
            C90.780861,369.627441 93.801964,374.228699 97.720726,379.961548 
            C97.720726,373.266449 97.720726,367.949707 97.720726,362.320129 
            C101.611847,362.320129 105.008377,362.320129 108.707077,362.320129 
            C108.707077,374.327789 108.707077,386.388550 108.707077,398.543304 
            C102.588173,399.971924 97.816551,399.336273 94.701492,392.627625 
            C92.597160,388.095642 88.838867,384.331696 85.070473,379.203705 
            C85.070473,386.500244 85.070473,392.418701 85.070473,398.980530 
            C77.708076,398.980530 70.607010,399.029297 63.508644,398.912994 
            C62.706352,398.899872 61.263870,397.998047 61.228081,397.437500 
            C60.920361,392.617981 57.655716,392.844299 54.246048,392.978333 
            C50.041569,393.143616 45.040497,391.443420 43.862156,397.998230 
            C43.779358,398.458832 42.326012,398.906006 41.487148,398.953156 
            C39.163067,399.083771 36.774933,398.682831 34.504665,399.055634 
            C25.413630,400.548401 18.732214,398.228516 16.056057,388.485107 
            C15.740025,387.334473 14.106625,386.545685 12.109800,384.678101 
            C12.109800,390.273071 12.109800,394.354858 12.109800,399.000000 
            C8.468109,399.000000 5.196998,399.000000 1.462943,399.000000 
            C1.000000,386.979095 1.000000,374.958221 1.000000,362.468658 
          M13.558507,370.013519 
            C12.863618,372.529938 12.168730,375.046326 11.364662,377.958099 
            C14.054008,377.958099 15.806083,378.459381 16.965799,377.844147 
            C18.845648,376.846832 20.336889,375.117065 21.992205,373.696533 
            C20.142460,372.464752 18.330299,371.169006 16.417280,370.044922 
            C15.922420,369.754150 15.111358,370.001526 13.558507,370.013519 
          M49.076061,382.793793 
            C51.523827,383.335175 53.971592,383.876526 57.059505,384.559479 
            C55.495876,380.101166 54.272137,376.611938 52.760147,372.300873 
            C51.403500,376.294556 50.425045,379.174896 49.076061,382.793793 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M63.458069,450.000000 
            C63.000000,437.884369 63.000000,425.768738 63.000000,413.039703 
            C70.770164,413.039703 78.367607,412.666779 85.905655,413.174835 
            C90.690231,413.497314 94.398354,417.938843 94.885849,423.342682 
            C95.384377,428.868774 93.406036,433.571533 88.310181,436.491333 
            C90.525452,440.722717 92.758530,444.988159 94.995804,449.626770 
            C91.307091,450.000000 87.614182,450.000000 83.456390,449.625732 
            C80.354591,445.084961 79.950485,439.322296 74.000000,436.256042 
            C74.000000,441.487366 74.000000,445.743683 74.000000,450.000000 
            C70.638710,450.000000 67.277428,450.000000 63.458069,450.000000 
          M74.011452,423.644745 
            C74.011452,425.388336 74.011452,427.131927 74.011452,429.475739 
            C77.076790,428.913696 79.565125,428.820709 81.707489,427.912018 
            C82.785057,427.454987 83.732933,425.531097 83.771149,424.241852 
            C83.792374,423.525909 81.860153,422.199280 80.739441,422.119812 
            C78.550316,421.964569 76.312820,422.491394 74.011452,423.644745 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M179.454102,450.000000 
            C179.000000,437.871735 179.000000,425.743469 179.000000,413.012695 
            C186.659821,413.012695 194.213257,412.205811 201.443268,413.383850 
            C204.627441,413.902679 208.627579,418.009338 209.623489,421.287292 
            C211.012985,425.860657 210.908691,431.467743 205.917206,435.015167 
            C205.258453,435.483337 204.634491,436.000427 204.101547,436.412048 
            C206.115402,440.788483 208.057327,445.008606 209.999634,449.614349 
            C206.638718,450.000000 203.277420,450.000000 199.362488,449.653137 
            C197.168655,446.020081 195.720673,442.614868 193.795547,439.505096 
            C193.003220,438.225189 191.184082,437.580933 189.000000,436.073212 
            C189.000000,441.796722 189.000000,445.898376 189.000000,450.000000 
            C185.969406,450.000000 182.938812,450.000000 179.454102,450.000000 
          M198.850616,427.573608 
            C198.852356,426.156372 199.183685,423.611176 198.803741,423.500183 
            C195.730789,422.602295 192.524261,422.161560 189.300323,421.570709 
            C189.300323,424.688812 189.300323,426.739410 189.300323,429.452148 
            C192.501938,428.916687 195.314117,428.446320 198.850616,427.573608 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M121.464645,450.000000 
            C120.053604,449.538727 119.122520,449.042297 118.158363,448.621735 
            C110.949059,445.477600 110.632561,444.310547 115.948479,438.500427 
            C116.569405,437.821747 118.440102,437.892731 119.596558,438.172913 
            C122.842735,438.959320 125.974037,440.300049 129.246811,440.851562 
            C130.337738,441.035431 131.719742,439.492218 132.968674,438.738525 
            C131.821213,437.830627 130.806259,436.536560 129.500946,436.088684 
            C125.879005,434.845795 121.993637,434.302246 118.470108,432.854858 
            C110.514732,429.586975 111.648567,418.238770 118.592903,414.181183 
            C124.933495,410.476410 138.654236,411.594116 143.134399,418.033875 
            C141.448853,420.244568 139.695938,422.543640 138.525070,424.079285 
            C133.658829,423.044678 129.525391,422.081421 125.345024,421.410645 
            C124.937126,421.345184 124.239975,423.082428 123.450829,424.344879 
            C127.821976,425.628937 131.665146,426.690399 135.464981,427.889252 
            C141.841995,429.901215 144.017014,432.417755 143.999939,437.549408 
            C143.980515,443.385864 140.867493,447.562439 135.119843,449.651306 
            C130.643097,450.000000 126.286201,450.000000 121.464645,450.000000 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M273.000000,391.550018 
            C263.857971,401.253082 251.140167,401.770020 240.874786,393.126068 
            C242.468872,390.778198 244.081726,388.402679 245.832245,385.824432 
            C251.355865,387.286255 256.548218,393.660583 263.776062,386.849884 
            C259.787140,385.747467 256.396790,385.279999 253.452332,383.876892 
            C249.838135,382.154602 245.206970,380.427856 243.472733,377.328217 
            C239.411652,370.069641 245.318405,361.344513 254.230377,361.182800 
            C258.937805,361.097382 263.707275,362.751312 268.396240,363.845062 
            C272.321106,364.760559 273.182861,366.749908 270.055237,369.838379 
            C268.909729,370.969604 268.050873,372.391144 267.405884,373.231323 
            C263.203125,372.076202 259.469238,370.928101 255.665222,370.103760 
            C254.871979,369.931854 253.819366,370.956818 252.886261,371.430206 
            C252.824432,371.974396 252.762604,372.518585 252.700775,373.062744 
            C256.073120,374.040741 259.424500,375.100220 262.823303,375.975647 
            C266.901764,377.026093 270.512817,378.630280 272.663635,382.896057 
            C273.000000,385.700012 273.000000,388.400024 273.000000,391.550018 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M147.468658,450.000000 
            C147.000000,437.867096 147.000000,425.734192 147.000000,413.301514 
            C155.986343,413.301514 164.712860,413.301514 173.721283,413.301514 
            C173.721283,416.031311 173.721283,418.758942 173.721283,421.942627 
            C168.260849,421.942627 162.842560,421.942627 157.223969,421.942627 
            C157.223969,423.785400 157.223969,425.179474 157.223969,427.020721 
            C162.799545,427.020721 168.220306,427.020721 173.809952,427.020721 
            C173.809952,429.748230 173.809952,432.033234 173.809952,434.774841 
            C168.474380,434.774841 163.060471,434.774841 157.248184,434.774841 
            C157.143356,436.936951 157.059387,438.669006 156.953201,440.859100 
            C162.611145,440.859100 168.026230,440.859100 174.000000,440.859100 
            C174.000000,443.875977 174.000000,446.479492 174.000000,449.541504 
            C165.312439,450.000000 156.624863,450.000000 147.468658,450.000000 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M99.454109,450.000000 
            C99.000000,437.870270 99.000000,425.740570 99.000000,413.306335 
            C102.307930,413.306335 105.370728,413.306335 109.000000,413.306335 
            C109.000000,425.210327 109.000000,437.136505 109.000000,449.531342 
            C105.969406,450.000000 102.938812,450.000000 99.454109,450.000000 
          z"/>
        <path fill="#FFFFFF" opacity="1.000000" stroke="none"
          d="
          M189.454102,450.000000 
            C189.000000,445.898376 189.000000,441.796722 189.000000,436.073212 
            C191.184082,437.580933 193.003220,438.225189 193.795547,439.505096 
            C195.720673,442.614868 197.168655,446.020081 198.904419,449.653137 
            C195.969406,450.000000 192.938812,450.000000 189.454102,450.000000 
          z"/>
        <path fill="#FFFFFF" opacity="1.000000" stroke="none"
          d="
          M74.449982,450.000000 
            C74.000000,445.743683 74.000000,441.487366 74.000000,436.256042 
            C79.950485,439.322296 80.354591,445.084961 82.995758,449.625732 
            C80.299988,450.000000 77.599968,450.000000 74.449982,450.000000 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M173.472839,362.000946 
            C176.945007,365.378326 180.094116,368.662354 182.979218,372.163910 
            C184.899170,374.494110 186.442261,377.134766 188.832397,380.627838 
            C188.832397,373.862732 188.832397,368.202515 188.832397,362.278198 
            C192.360977,362.278198 195.420380,362.278198 198.742844,362.278198 
            C198.742844,374.387909 198.742844,386.437500 198.742844,398.484253 
            C192.556686,400.501862 188.464569,398.197479 185.304169,392.849213 
            C182.518555,388.135132 179.181412,383.746979 175.256958,377.997742 
            C175.256958,385.746063 175.256958,392.058228 175.256958,398.682587 
            C171.716736,398.682587 168.655823,398.682587 165.293732,398.682587 
            C165.293732,386.694519 165.293732,374.646484 165.293732,362.000122 
            C167.842041,362.000122 170.439789,362.000122 173.472839,362.000946 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M238.920212,392.167664 
            C227.262009,404.482849 208.169968,400.388885 203.496429,385.004761 
            C200.829208,376.225037 205.743256,365.868103 213.952759,362.966766 
            C225.977844,358.716980 235.083450,361.421692 238.924652,370.425415 
            C237.370544,371.268524 235.877670,372.619904 234.236816,372.833282 
            C232.124359,373.107971 229.246307,373.252228 227.832474,372.081970 
            C223.263702,368.300507 219.166397,370.462311 215.807297,373.860199 
            C212.317322,377.390442 213.427368,384.561188 217.496338,387.969635 
            C221.318207,391.171112 225.361389,390.793060 229.255539,386.460358 
            C227.745407,386.280762 226.568680,386.080627 225.384567,386.016144 
            C224.086594,385.945526 222.781799,386.000061 221.247009,386.000061 
            C221.247009,382.946075 221.247009,380.211395 221.247009,377.236450 
            C227.104858,377.236450 232.830154,377.236450 238.984207,377.236450 
            C238.984207,382.190765 238.984207,386.969543 238.920212,392.167664 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M142.762192,367.734955 
            C140.246490,370.593048 137.980927,373.189331 135.723602,375.792786 
            C133.666199,378.165619 134.113297,380.257324 136.044556,382.607880 
            C140.167694,387.626343 144.060028,392.834473 148.080658,398.008270 
            C138.693878,401.300659 135.904007,399.766846 126.849800,386.488342 
            C124.878250,387.930817 124.878250,387.930817 123.555222,398.783264 
            C120.643578,398.783264 117.693832,398.783264 114.369957,398.783264 
            C114.369957,386.847015 114.369957,374.790802 114.369957,362.366150 
            C117.193199,362.366150 120.254807,362.366150 123.740723,362.366150 
            C123.740723,366.226746 123.740723,370.295288 123.740723,375.764832 
            C126.679741,371.997498 129.200638,369.504700 130.810623,366.520447 
            C132.951920,362.551361 135.945908,361.463257 140.102554,361.957062 
            C142.178650,362.203705 144.308243,362.000000 147.084991,362.000000 
            C145.464691,364.180664 144.240295,365.828461 142.762192,367.734955 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M160.000000,380.000427 
            C160.000000,386.458344 160.000000,392.416718 160.000000,398.686584 
            C156.380402,398.686584 152.990204,398.686584 149.295685,398.686584 
            C149.295685,386.703369 149.295685,374.666656 149.295685,362.313904 
            C152.621399,362.313904 156.011002,362.313904 160.000000,362.313904 
            C160.000000,368.002686 160.000000,373.751770 160.000000,380.000427 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M5.129249,252.274445 
            C5.424387,252.106323 5.634987,252.261795 5.890280,252.657211 
            C5.685341,252.733627 5.388587,252.633911 5.129249,252.274445 
          z"/>
        <path fill="#FFFFFF" opacity="1.000000" stroke="none"
          d="
          M152.833344,165.014313 
            C152.882462,134.647644 152.931564,104.280968 152.943970,73.189438 
            C152.609604,72.365265 152.311966,72.265961 152.014313,72.166656 
            C146.216782,72.166656 140.419266,72.166656 133.384232,72.166656 
            C146.833969,54.459724 159.654205,37.581562 172.974030,20.045670 
            C186.274887,37.581245 199.082123,54.466045 212.378540,71.995758 
            C205.463333,71.995758 199.532684,71.995758 193.304291,71.995758 
            C193.304291,85.318062 193.304291,98.380646 193.304291,111.722710 
            C197.036850,111.722710 200.767075,111.722710 204.913239,111.722710 
            C204.913239,102.549507 204.913239,93.454559 204.913239,82.729820 
            C210.495560,85.587410 215.219269,87.772362 219.714249,90.355370 
            C228.841736,95.600410 237.773331,101.188713 246.942001,106.358276 
            C249.894882,108.023193 251.083786,109.871780 251.073776,113.319969 
            C250.958176,153.143661 250.932892,192.968048 251.078888,232.791550 
            C251.098709,238.199417 251.246170,243.083115 244.074890,244.196304 
            C244.074890,203.459213 244.074890,162.465607 244.074890,121.237488 
            C221.879349,121.237488 200.152710,121.237488 178.000000,121.237488 
            C178.000000,123.225372 178.000000,125.014404 178.000000,126.803436 
            C178.000000,176.791763 177.868668,226.780853 178.165878,276.767426 
            C178.203110,283.030884 176.049683,286.105164 170.131683,287.495941 
            C170.131683,249.537292 170.131683,211.638214 170.131683,173.369873 
            C148.148605,173.369873 126.420364,173.369873 104.276215,173.369873 
            C104.276215,211.236221 104.276215,249.298843 104.276215,287.791046 
            C101.249809,286.192078 98.720222,284.855591 95.969818,283.402466 
            C95.969818,259.541656 95.969818,235.576324 95.969818,211.306274 
            C74.019020,211.306274 52.291962,211.306274 30.171253,211.306274 
            C30.171253,222.056396 30.171253,232.818893 30.171253,243.940613 
            C25.900160,243.126587 23.922752,241.370193 23.934168,237.043625 
            C24.044077,195.386978 23.970028,153.729828 24.106964,112.073341 
            C24.112587,110.363174 25.229691,107.908287 26.603188,107.072105 
            C35.721279,101.521057 45.050774,96.317268 54.681053,91.234467 
            C55.328300,91.658836 55.605991,91.849266 55.934982,92.484894 
            C56.942760,100.499809 57.544167,108.135963 58.945198,115.622490 
            C60.713398,125.070961 60.869934,125.117172 52.669998,130.874344 
            C45.692001,135.773590 38.855988,140.875061 31.700417,145.980408 
            C31.629114,146.327087 31.814558,146.580429 32.363018,147.016052 
            C40.808105,148.798874 48.839584,150.761627 56.986263,151.899643 
            C65.395180,153.074295 65.443459,152.723618 68.015312,160.706924 
            C70.731438,169.138092 73.449188,177.568726 76.131256,186.269714 
            C76.435135,186.374191 76.773987,186.208542 77.432030,185.905884 
            C83.343391,175.953369 88.935562,166.137894 94.236641,156.833344 
            C105.260284,156.833344 116.131187,156.833344 127.345863,156.905670 
            C128.350952,156.916733 129.012253,156.855499 130.413498,156.725723 
            C129.221527,155.849655 128.641312,155.423233 127.949799,154.683502 
            C121.501526,147.684677 115.198792,140.966187 108.808739,134.331818 
            C106.622093,132.061569 105.622017,129.986481 106.888199,126.593498 
            C110.141579,117.875496 112.885384,108.967339 115.907990,99.835770 
            C116.167519,98.744392 116.351913,97.952423 116.664413,96.610252 
            C115.461769,97.175552 114.711823,97.528061 113.592514,97.938026 
            C103.634384,102.511795 94.045631,107.028107 84.362259,111.588989 
            C82.615486,110.240379 80.733101,108.688087 78.751503,107.274895 
            C71.556595,102.143791 64.328461,97.059288 56.980045,91.656372 
            C56.215946,91.251572 55.584660,91.147598 54.953373,91.043625 
            C65.443939,84.719719 75.893532,78.326591 86.434418,72.087692 
            C103.416481,62.036404 120.458740,52.086815 138.783600,42.625385 
            C138.303833,44.133305 138.186218,45.913876 137.288071,47.106796 
            C128.674622,58.547207 119.929390,69.888405 110.799973,81.695930 
            C110.585655,82.700356 110.793289,83.266884 111.000916,83.833420 
            C120.773766,83.833420 130.546616,83.833420 141.019333,83.833420 
            C141.019333,110.816582 141.019333,137.451126 141.056030,164.810547 
            C141.390396,165.634735 141.688034,165.734039 141.985687,165.833344 
            C145.028229,165.882294 148.070786,165.931259 151.824371,165.943726 
            C152.634735,165.609604 152.734039,165.311966 152.833344,165.014313 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M110.999374,83.508835 
            C110.793289,83.266884 110.585655,82.700356 110.667496,82.010132 
            C110.970589,82.319046 110.984207,82.751648 110.999374,83.508835 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M152.657471,165.107330 
            C152.734039,165.311966 152.634735,165.609604 152.274979,165.870300 
            C152.106659,165.575439 152.262344,165.364426 152.657471,165.107330 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M141.892670,165.657471 
            C141.688034,165.734039 141.390396,165.634735 141.129700,165.274979 
            C141.424561,165.106659 141.635574,165.262344 141.892670,165.657471 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M152.107315,72.342537 
            C152.311966,72.265961 152.609604,72.365265 152.870300,72.725021 
            C152.575424,72.893364 152.364410,72.737686 152.107315,72.342537 
          z"/>
        <path fill="#FFFFFF" opacity="1.000000" stroke="none"
          d="
          M14.002028,370.007599 
            C15.111358,370.001526 15.922420,369.754150 16.417280,370.044922 
            C18.330299,371.169006 20.142460,372.464752 21.992207,373.696533 
            C20.336889,375.117065 18.845648,376.846832 16.965799,377.844147 
            C15.806083,378.459381 14.054008,377.958099 11.364662,377.958099 
            C12.168730,375.046326 12.863618,372.529938 14.002028,370.007599 
          z"/>
        <path fill="#FFFFFF" opacity="1.000000" stroke="none"
          d="
          M49.261326,382.424530 
            C50.425045,379.174896 51.403500,376.294556 52.760147,372.300873 
            C54.272137,376.611938 55.495876,380.101166 57.059505,384.559479 
            C53.971592,383.876526 51.523827,383.335175 49.261326,382.424530 
          z"/>
        <path fill="#FFFFFF" opacity="1.000000" stroke="none"
          d="
          M74.053398,423.190277 
            C76.312820,422.491394 78.550316,421.964569 80.739441,422.119812 
            C81.860153,422.199280 83.792374,423.525909 83.771149,424.241852 
            C83.732933,425.531097 82.785057,427.454987 81.707489,427.912018 
            C79.565125,428.820709 77.076790,428.913696 74.011452,429.475739 
            C74.011452,427.131927 74.011452,425.388336 74.053398,423.190277 
          z"/>
        <path fill="#FFFFFF" opacity="1.000000" stroke="none"
          d="
          M198.488464,427.774780 
            C195.314117,428.446320 192.501938,428.916687 189.300323,429.452148 
            C189.300323,426.739410 189.300323,424.688812 189.300323,421.570709 
            C192.524261,422.161560 195.730789,422.602295 198.803741,423.500183 
            C199.183685,423.611176 198.852356,426.156372 198.488464,427.774780 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M115.832855,100.135185 
            C112.885384,108.967339 110.141579,117.875496 106.888199,126.593498 
            C105.622017,129.986481 106.622093,132.061569 108.808739,134.331818 
            C115.198792,140.966187 121.501526,147.684677 127.608437,155.101654 
            C127.252953,156.166519 127.127518,156.499924 127.002083,156.833344 
            C116.131187,156.833344 105.260284,156.833344 94.236641,156.833344 
            C88.935562,166.137894 83.343391,175.953369 77.195557,185.889496 
            C76.639893,186.010147 76.166229,185.999588 76.166229,185.999588 
            C73.449188,177.568726 70.731438,169.138092 68.015312,160.706924 
            C65.443459,152.723618 65.395180,153.074295 56.986263,151.899643 
            C48.839584,150.761627 40.808105,148.798874 32.357353,146.779205 
            C31.988678,146.360077 31.957167,145.887070 31.957165,145.887070 
            C38.855988,140.875061 45.692001,135.773590 52.669998,130.874344 
            C60.869934,125.117172 60.713398,125.070961 58.945198,115.622490 
            C57.544167,108.135963 56.942760,100.499809 56.242401,92.464722 
            C56.703293,91.985306 56.908073,91.971260 57.112858,91.957207 
            C64.328461,97.059288 71.556595,102.143791 78.751503,107.274895 
            C80.733101,108.688087 82.615486,110.240379 84.362259,111.588989 
            C94.045631,107.028107 103.634384,102.511795 113.667435,98.332489 
            C114.685440,99.158066 115.259148,99.646629 115.832855,100.135185 
          M68.362999,131.128891 
            C63.695328,134.615768 59.027660,138.102646 53.649506,142.120270 
            C60.311932,143.225449 66.163124,144.196045 72.200317,145.518417 
            C72.364380,145.737732 72.575386,145.893417 73.162300,146.681046 
            C74.996956,152.090988 76.831604,157.500946 79.081055,164.134018 
            C82.410042,158.217224 85.288353,153.101456 88.518417,147.799683 
            C88.737686,147.635590 88.893364,147.424576 89.913002,147.019394 
            C95.595711,147.019394 101.278412,147.019394 107.605324,147.019394 
            C106.753983,145.626007 106.600830,145.090286 106.246002,144.836243 
            C97.102257,138.289490 92.646835,130.436462 99.068474,119.487320 
            C99.147804,119.352058 99.135948,119.163322 99.872025,118.830048 
            C100.231842,117.381165 100.591660,115.932281 100.951477,114.483398 
            C100.454048,114.209099 99.956619,113.934799 99.459190,113.660500 
            C98.306213,114.718117 97.153236,115.775726 95.262917,116.988899 
            C93.382545,117.910530 91.485023,118.798988 89.625305,119.760551 
            C85.482040,121.902802 81.823463,122.783516 77.909805,118.657005 
            C75.005180,115.594398 70.992149,113.583015 67.518562,111.135612 
            C68.044479,117.260727 68.543564,123.073372 69.012634,129.534805 
            C69.008156,129.967682 69.003677,130.400543 68.362999,131.128891 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M115.907990,99.835770 
            C115.259148,99.646629 114.685440,99.158066 114.036804,98.275040 
            C114.711823,97.528061 115.461769,97.175552 116.664413,96.610252 
            C116.351913,97.952423 116.167519,98.744392 115.907990,99.835770 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M127.345863,156.905670 
            C127.127518,156.499924 127.252953,156.166519 127.719749,155.414948 
            C128.641312,155.423233 129.221527,155.849655 130.413498,156.725723 
            C129.012253,156.855499 128.350952,156.916733 127.345863,156.905670 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M56.980045,91.656372 
            C56.908073,91.971260 56.703293,91.985306 56.191093,92.019516 
            C55.605991,91.849266 55.328300,91.658836 55.052258,91.204063 
            C55.053905,90.939720 55.005161,90.993134 54.979267,91.018379 
            C55.584660,91.147598 56.215946,91.251572 56.980045,91.656372 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M76.131256,186.269714 
            C76.166229,185.999588 76.639893,186.010147 76.876366,186.026520 
            C76.773987,186.208542 76.435135,186.374191 76.131256,186.269714 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M31.700418,145.980408 
            C31.957167,145.887070 31.988678,146.360077 31.994341,146.596924 
            C31.814558,146.580429 31.629114,146.327087 31.700418,145.980408 
          z"/>
        <path fill="#FFFFFF" opacity="1.000000" stroke="none"
          d="
          M88.166656,147.985687 
            C85.288353,153.101456 82.410042,158.217224 79.081055,164.134018 
            C76.831604,157.500946 74.996956,152.090988 73.034775,146.072815 
            C72.609612,145.365265 72.311966,145.265961 72.014320,145.166656 
            C66.163124,144.196045 60.311932,143.225449 53.649506,142.120270 
            C59.027660,138.102646 63.695328,134.615768 68.994080,130.978363 
            C69.430992,130.180557 69.236824,129.533279 69.042648,128.886017 
            C68.543564,123.073372 68.044479,117.260727 67.518562,111.135612 
            C70.992149,113.583015 75.005180,115.594398 77.909805,118.657005 
            C81.823463,122.783516 85.482040,121.902802 89.625305,119.760551 
            C91.485023,118.798988 93.382545,117.910530 96.006500,116.984909 
            C97.555603,117.653793 98.361130,118.326668 99.166656,118.999542 
            C99.135948,119.163322 99.147804,119.352058 99.068474,119.487320 
            C92.646835,130.436462 97.102257,138.289490 106.246002,144.836243 
            C106.600830,145.090286 106.753983,145.626007 107.605324,147.019394 
            C101.278412,147.019394 95.595711,147.019394 89.188782,147.056061 
            C88.365265,147.390396 88.265961,147.688034 88.166656,147.985687 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M99.519341,118.914795 
            C98.361130,118.326668 97.555603,117.653793 96.375175,116.907127 
            C97.153236,115.775726 98.306213,114.718117 99.459190,113.660500 
            C99.956619,113.934799 100.454048,114.209099 100.951477,114.483398 
            C100.591660,115.932281 100.231842,117.381165 99.519341,118.914795 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M69.027641,129.210419 
            C69.236824,129.533279 69.430992,130.180557 69.312180,130.830627 
            C69.003677,130.400543 69.008156,129.967682 69.027641,129.210419 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M88.342537,147.892685 
            C88.265961,147.688034 88.365265,147.390396 88.725021,147.129700 
            C88.893364,147.424576 88.737686,147.635590 88.342537,147.892685 
          z"/>
        <path fill="#C11920" opacity="1.000000" stroke="none"
          d="
          M72.107315,145.342529 
            C72.311966,145.265961 72.609612,145.365265 72.870300,145.725021 
            C72.575386,145.893417 72.364380,145.737732 72.107315,145.342529 
          z"/>
      </svg>
    </Icon>
  )
}

export default React.forwardRef(RankingRiserIcon);
